import { defa }          from 'defa-object';
import ControlModel      from 'scripts/poppet/control-model';

/**
 * defa.models.TemperatureAlert
 * The DEFA TemperatureAlert model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	homeAutomation : '/homeAutomation/masterControl?attrs=',
};

const TemperatureAlert = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('id') + api.homeAutomation + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{
			// Temperature alert
			alarmMask: null,
			alarmMaskError: null,
			// highTemp : false,
			// lowTemp  : false,
		}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			
			if(response.alarmMask){
				this.parseAttribute('alarmMask', response.alarmMask, options, newModelAttributes);
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'temperatureAlerts' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	toBackendJSON: function() {
		return {
			alarmMask: {
				highTemp: 'ON' === this.get('temperatureEnabled'),
				lowTemp : 'ON' === this.get('temperatureEnabled'),
			}
		};
	},
	
	getAttributes: function() {
		return 'alarmMask';
	},
	
} );

export default TemperatureAlert;
